import Trame from './modale.creation.trame.model';

export default class ModaleCreationTrameController {
    static $inject = ['$scope', '$uibModalInstance', '$translate', 'notification', 'data'];

    constructor($scope, $uibModalInstance, $translate, notification, data) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$translate = $translate;
        this.notification = notification;
        this.data = data;
        this.trame = new Trame();
        this.TrameService = data.service;
        this.parentNode = data.parentNode;
    }

    $onInit() {
        this.nom = {};
        this.type = {};
        this.loading = false;
        this.codeLoading = false;
        this.getTypes();
    }

    async getTypes() {
        this.types = await this.TrameService.getAvailableTypes();
    }

    async confirmer() {
        if (this.trame.isValid()) {
            let result = false;

            try {
                this.startLoading();
                result = await this.TrameService.createNode(this.parentNode, this.trame);
                this.notification.success(this.$translate.instant('AJOUTER_SUCCESS', { entity: this.trame.nom }));
                this.$uibModalInstance.close(result);
            } catch (ex) {
                this.notification.error(ex.data);
            } finally {
                this.stopLoading();
            }
        } else {
            this.$scope.$broadcast('TrameValidations');
        }
    }

    async checkCodeUnicity(code) {
        if (code) {
            this.startCodeLoading();

            try {
                if (code.match(/^[a-zA-Z0-9_|]*$/)) {
                    this.trame.codeExists = await this.TrameService.codeExists(code);
                }
            } catch (ex) {
                this.notification.error(ex.data);
            } finally {
                this.stopCodeLoading();
            }
        } else {
            this.trame.codeExists = null;
        }
    }

    annuler() {
        this.$uibModalInstance.dismiss();
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    startCodeLoading() {
        this.codeLoading = true;
    }

    stopCodeLoading() {
        this.codeLoading = false;
    }
}
